import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	ViewChild,
} from '@angular/core';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { TYPE_TOAST } from 'src/app/models/enumeraciones';
import { FullSizeLoadingService } from 'src/app/services/utils/full-size-loading.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
	selector: 'cmv-app-base-layout',
	templateUrl: './base-layout.component.html',
	styleUrls: ['./base-layout.component.scss'],
})
export class BaseLayoutComponent implements AfterViewInit {
	@ViewChild('toastContainer') toastContainer: ElementRef;

	loading$: Observable<boolean> = this.fullSizeLoadingService.loading$;
	message$: Observable<string> = this.fullSizeLoadingService.message$;

	toast$: Observable<boolean>;

	constructor(
		private toastService: ToastrService,
		private utilsService: UtilsService,
		private fullSizeLoadingService: FullSizeLoadingService,
		private cd: ChangeDetectorRef
	) {
		utilsService.toast$.subscribe((response: any) => {
			if (response) {
				this.ShowToast(response.mensaje, response.typeToast, response.timeOut);
			}
		});
	}

	ngAfterViewInit() {
		this.toastService.overlayContainer = new ToastContainerDirective(
			this.toastContainer
		);
		this.cd.detectChanges();
	}

	ShowToast(
		mensaje: string,
		typeToast: TYPE_TOAST = TYPE_TOAST.SUCCESS,
		timeOut: number = 5000
	) {
		let options = {
			closeButton: true,
			timeOut: timeOut,
			progressBar: true,
			positionClass: 'toast-bottom-center',
		};
		switch (typeToast) {
			case TYPE_TOAST.SUCCESS:
				this.toastService.success(mensaje, '', options);
				break;
			case TYPE_TOAST.ERROR:
				this.toastService.error(mensaje, '', options);
				break;
			case TYPE_TOAST.INFO:
				this.toastService.info(mensaje, '', options);
				break;
			case TYPE_TOAST.WARNING:
				this.toastService.warning(mensaje, '', options);
				break;
		}
	}

	MuestraErrorInterno(ex?: any) {
		this.toastService.error(
			ex.error.message || 'Ocurrio un error, intente mas tarde.',
			'',
			{
				closeButton: true,
				progressBar: true,
			}
		);
	}
}
